import { all } from 'redux-saga/effects';
import employeePayrollWatcher from './employee-Payroll-saga';

export default function* rootSaga(action) {
	yield all([employeePayrollWatcher(action)]);
}
